var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCategories(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    fill: "none",
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#122442",
    d: "M15.445 2h-4.583c-.272 0-.492.22-.492.492v4.586c0 .272.22.493.492.493h1.806l.024 3.133H7.568V8.906c0-.272-.22-.492-.492-.492H2.49c-.27 0-.49.22-.49.492v4.583c0 .272.22.493.49.493h4.586c.272 0 .492-.22.492-.493v-1.798H12.7l.046 5.819H10.07v-1.804c0-.272-.22-.492-.492-.492H4.992c-.272 0-.492.22-.492.492v4.586c0 .272.22.492.492.492h4.586c.272 0 .492-.22.492-.492V18.49h3.175c.272 0 .49-.223.487-.492l-.05-3.806h2.35v1.8c0 .273.22.493.493.493h4.583c.272 0 .492-.22.492-.492v-4.583c0-.272-.22-.495-.492-.495h-4.583c-.272 0-.492.223-.492.495v1.797h-2.359l-.024-5.635h1.795c.272 0 .492-.22.492-.493V2.492c0-.272-.22-.492-.492-.492z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCategories);
export default __webpack_public_path__ + "static/media/icon-categories.4c90172a.svg";
export { ForwardRef as ReactComponent };